import {TRACKING_QUERY_PARAMS} from './constants';
import {getDeviceCategory} from './hooks';
import {SignupForm} from './types';
import {useNormalizedQueryParams} from './utils';
import {useMutation} from '@tanstack/react-query';
import {ErrorResponse} from 'react-router-dom';
import {SIGNUP_API_URL} from '~/App';

export interface SignupRequestResponse {
  isSuccess: boolean;
  failureMessage?: string;
  outputModel?: {
    requestId?: string;
    status?: 'SUCCESSFUL' | 'FAILED';
    autoLoginUrl?: string;
    portalUrl?: string;
    portalId?: 0;
  };
}

export const useSignupRequestMutation = () => {
  const normalizedQueryParams = useNormalizedQueryParams(TRACKING_QUERY_PARAMS);

  return useMutation<SignupRequestResponse, ErrorResponse, SignupForm>({
    mutationFn: async (form: SignupForm) => {
      const response = await fetch(`${SIGNUP_API_URL}/signup`, {
        method: 'POST',
        body: JSON.stringify({
          ...form,
          ...normalizedQueryParams,
          source: 1,
          consentToMarketing: true,
          acceptRules: true,
          leadSource: 'Web&Marketing',
          firstEntryPoint: 'free trial form',
          conversionUrl: window.location.href,
          entryReferrerUrl:
            normalizedQueryParams?.entryReferrerUrl || document.referrer,
          conversionDeviceCategory: getDeviceCategory(),
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        }),
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`Signup request failed: ${response.statusText}`);
      }

      return response.json();
    },
  });
};
